import { ReactElement } from "react";
import styles from "./legal.module.scss";

export const Legal = (props: Props): ReactElement => {
  return (
    <section className={styles.base}>
      <div className={styles.header}>
        <div className={styles.container}>
          <p className={styles.badgeText}>{props.badgeText}</p>
          <h1 className={styles.title}>{props.title}</h1>
          <p className={styles.description}>{props.description}</p>
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.container}>
          <article
            className={styles.article}
            dangerouslySetInnerHTML={{ __html: props.content }}
          ></article>
        </div>
      </div>
    </section>
  );
};

interface Props {
  badgeText: string;
  title: string;
  description: string;
  content: string;
}
